<template>
  <div class="single-event-page">
    <div class="single-page-top">
      <AssociationEventTop
        :association_id="association_id"
        :events="events"
        :currentIsAdmin="currentIsAdmin"
        :eventId="eventId"
        :showLoader="showLoader"
        @followed="incrementFollowerCount"
        @unfollowed="decrementFollowerCount"
      />
      <ul class="nav nav-tabs mt-3" id="myTab" role="tablist">
        <li
          class="nav-item"
          role="presentation"
          v-if="tournamentsLength.length > 0"
        >
          <button
            class="nav-link"
            :class="{
              active: currentTab === 'schedule',
              disabled: isLoaded.schedule,
            }"
            id="schedule-tab"
            data-toggle="tab"
            data-target="#schedule"
            type="button"
            role="tab"
            aria-controls="schedule"
            aria-selected="true"
            @click="selectTab('schedule')"
          >
            Schedules & Brackets
          </button>
        </li>
        <li
          class="nav-item"
          role="presentation"
          v-if="tournamentsLength.length > 0"
        >
          <button
            class="nav-link"
            :class="{
              active: currentTab === 'boxscore',
              disabled: isLoaded.boxscore,
            }"
            id="boxscore-tab"
            data-toggle="tab"
            data-target="#boxscore"
            type="button"
            role="tab"
            aria-controls="boxscore"
            aria-selected="true"
            @click="selectTab('boxscore')"
          >
            Boxscores
          </button>
        </li>
        <li class="nav-item" role="presentation">
          <button
            class="nav-link"
            :class="{ active: currentTab === 'team', disabled: isLoaded.team }"
            id="team-tab"
            data-toggle="tab"
            data-target="#team"
            type="button"
            role="tab"
            aria-controls="team"
            aria-selected="true"
            @click="selectTab('team')"
          >
            Teams
          </button>
        </li>
        <li class="nav-item" role="presentation">
          <button
            class="nav-link"
            :class="{
              active: currentTab === 'tournament',
              disabled: isLoaded.tournament,
            }"
            id="tournament-tab"
            data-toggle="tab"
            data-target="#tournament"
            type="button"
            role="tab"
            aria-controls="tournament"
            aria-selected="false"
            @click="selectTab('tournament')"
          >
            Divisions
          </button>
        </li>
        <li class="nav-item" role="presentation">
          <button
            class="nav-link"
            :class="{
              active: currentTab === 'umpire',
              disabled: isLoaded.umpire,
            }"
            id="umpire-tab"
            data-toggle="tab"
            data-target="#umpire"
            type="button"
            role="tab"
            aria-controls="umpire"
            aria-selected="false"
            @click="selectTab('umpire')"
          >
            Umpires
          </button>
        </li>
        <li class="nav-item" role="presentation">
          <button
            class="nav-link"
            :class="{
              active: currentTab === 'grid',
              disabled: isLoaded.grid,
            }"
            id="grid-tab"
            data-toggle="tab"
            data-target="#grid"
            type="button"
            role="tab"
            aria-controls="grid"
            aria-selected="false"
            @click="selectTab('grid')"
          >
            Field Grid
          </button>
        </li>
        <li class="nav-item" role="presentation">
          <button
            class="nav-link"
            :class="{
              active: currentTab === 'message',
              disabled: isLoaded.message,
            }"
            id="message-tab"
            data-toggle="tab"
            data-target="#message"
            type="button"
            role="tab"
            aria-controls="message"
            @click="selectTab('message')"
            aria-selected="false"
          >
            Message Board
          </button>
        </li>
      </ul>
    </div>
    <div class="tab-content m-md-3 mt-3" id="myTabContent">
      <div
        class="tab-pane fade show active"
        :class="{ 'show active': currentTab === 'schedule' }"
        id="schedule"
        role="tabpanel"
        aria-labelledby="schedule-tab"
      >
        <div class="asso-main-wrapper">
          <AssociationScheduleInfo
            :association_id="association_id"
            :eventData="events"
            :eventExactStartDate="eventExactStartDate"
            :eventExactEndDate="eventExactEndDate"
            :tournamentsData="tournamentsData"
            :eventId="eventId"
            :currentIsAdmin="currentIsAdmin"
            :showLoaderTournament="showLoaderTournament"
            :currentIsUmpire="currentIsUmpire"
            v-if="currentTab === 'schedule'"
            @get-division-pagination="handleDivisionPagination"
          />

          <AssociationEventInfo
            :association_id="association_id"
            :events="events"
            :eventId="eventId"
            :showLoader="showLoader"
            :eventSponsors="eventSponsors"
            :currentIsAdmin="currentIsAdmin"
            :eventHotels="eventHotels"
            :sponsorLoader="sponsorLoader"
            :hotelLoader="hotelLoader"
            :eventPlayingFacility="eventPlayingFacility"
            :playingFacilityLoader="playingFacilityLoader"
            v-if="currentTab === 'schedule'"
          />
        </div>
      </div>
      <div
        class="tab-pane fade"
        :class="{ 'show active': currentTab === 'boxscore' }"
        id="boxscore"
        role="tabpanel"
        aria-labelledby="boxscore-tab"
      >
        <div class="asso-main-wrapper">
          <AssociationBoxScoresInfo
            :association_id="association_id"
            :eventExactStartDate="eventExactStartDate"
            :eventExactEndDate="eventExactEndDate"
            :tournamentsData="tournamentsData"
            :eventId="eventId"
            :currentIsAdmin="currentIsAdmin"
            :showLoaderTournament="showLoaderTournament"
            :currentIsUmpire="currentIsUmpire"
            v-if="currentTab === 'boxscore'"
            @get-division-pagination="handleDivisionPagination"
          />

          <AssociationEventInfo
            :association_id="association_id"
            :events="events"
            :eventId="eventId"
            :showLoader="showLoader"
            :eventSponsors="eventSponsors"
            :currentIsAdmin="currentIsAdmin"
            :eventHotels="eventHotels"
            :sponsorLoader="sponsorLoader"
            :hotelLoader="hotelLoader"
            :eventPlayingFacility="eventPlayingFacility"
            :playingFacilityLoader="playingFacilityLoader"
            v-if="currentTab === 'boxscore'"
          />
        </div>
      </div>
      <div
        class="tab-pane fade"
        :class="{ 'show active': currentTab === 'team' }"
        id="team"
        role="tabpanel"
        aria-labelledby="team-tab"
      >
        <div class="asso-main-wrapper">
          <AssociationTeamsInfo
            :eventId="eventId"
            :eventName="eventName"
            :association_id="association_id"
            :showLoaderTeam="showLoaderTeam"
            :currentIsAdmin="currentIsAdmin"
            :page="page"
            :lastPage="lastPage"
            :joinedTeams="joinedTeams"
            :tournamentsData="tournamentsData"
            :showLoaderTournament="showLoaderTournament"
            v-if="currentTab === 'team'"
            @get-division-pagination="handleDivisionPagination"
          />

          <AssociationEventInfo
            :association_id="association_id"
            :events="events"
            :eventId="eventId"
            :showLoader="showLoader"
            :eventSponsors="eventSponsors"
            :currentIsAdmin="currentIsAdmin"
            :eventHotels="eventHotels"
            :sponsorLoader="sponsorLoader"
            :hotelLoader="hotelLoader"
            :eventPlayingFacility="eventPlayingFacility"
            :playingFacilityLoader="playingFacilityLoader"
            v-if="currentTab === 'team'"
          />
        </div>
      </div>
      <div
        class="tab-pane fade"
        :class="{ 'show active': currentTab === 'tournament' }"
        id="tournament"
        role="tabpanel"
        aria-labelledby="tournament-tab"
      >
        <div class="asso-main-wrapper">
          <AssocaitionTournamentInfo
            :association_id="association_id"
            :eventExactStartDate="eventExactStartDate"
            :eventExactEndDate="eventExactEndDate"
            :tournamentsData="tournamentsData"
            :eventId="eventId"
            :events="events"
            :currentIsAdmin="currentIsAdmin"
            :showLoaderTournament="showLoaderTournament"
            :divisionPage="divisionPage"
            :divisionlastPage="divisionlastPage"
            :divisionsTotal="divisionsTotal"
            v-if="currentTab === 'tournament'"
            @get-division-pagination="handleDivisionPagination"
            @scrollToBoxScore="scrollToBoxScoreSection"
          />

          <AssociationEventInfo
            :association_id="association_id"
            :events="events"
            :eventId="eventId"
            :showLoader="showLoader"
            :eventSponsors="eventSponsors"
            :currentIsAdmin="currentIsAdmin"
            :eventHotels="eventHotels"
            :sponsorLoader="sponsorLoader"
            :hotelLoader="hotelLoader"
            :eventPlayingFacility="eventPlayingFacility"
            :playingFacilityLoader="playingFacilityLoader"
            v-if="currentTab === 'tournament'"
          />
        </div>
      </div>
      <div
        class="tab-pane fade"
        :class="{ 'show active': currentTab === 'umpire' }"
        id="umpire"
        role="tabpanel"
        aria-labelledby="umpire-tab"
      >
        <div class="asso-main-wrapper">
          <AssociationUmpiresInfo
            :eventId="eventId"
            :association_id="association_id"
            :umpireData="umpireData"
            :umpiresTotal="umpiresTotal"
            :showLoaderUmpire="showLoaderUmpire"
            :umpirepage="umpirepage"
            :umpirelastPage="umpirelastPage"
            :currentIsAdmin="currentIsAdmin"
            :tournamentsData="tournamentsData"
            :showLoaderTournament="showLoaderTournament"
            v-if="currentTab === 'umpire'"
            @get-division-pagination="handleDivisionPagination"
          />

          <AssociationEventInfo
            :association_id="association_id"
            :events="events"
            :eventId="eventId"
            :showLoader="showLoader"
            :eventSponsors="eventSponsors"
            :currentIsAdmin="currentIsAdmin"
            :eventHotels="eventHotels"
            :sponsorLoader="sponsorLoader"
            :hotelLoader="hotelLoader"
            :eventPlayingFacility="eventPlayingFacility"
            :playingFacilityLoader="playingFacilityLoader"
            v-if="currentTab === 'umpire'"
          />
        </div>
      </div>
      <div
        class="tab-pane fade"
        :class="{ 'show active': currentTab === 'grid' }"
        id="grid"
        role="tabpanel"
        aria-labelledby="grid-tab"
      >
        <div class="asso-main-wrapper">
          <AssociationFieldGridInfo
            ref="fieldGridComponent"
            :eventId="eventId"
            v-if="currentTab === 'grid'"
          />

          <!-- <AssociationEventInfo
            :association_id="association_id"
            :events="events"
            :eventId="eventId"
            :showLoader="showLoader"
            :eventSponsors="eventSponsors"
            :currentIsAdmin="currentIsAdmin"
            :eventHotels="eventHotels"
            :sponsorLoader="sponsorLoader"
            :hotelLoader="hotelLoader"
            :eventPlayingFacility="eventPlayingFacility"
            :playingFacilityLoader="playingFacilityLoader"
            v-if="currentTab === 'grid'"
          /> -->
        </div>
      </div>
      <div
        class="tab-pane fade"
        :class="{ 'show active': currentTab === 'message' }"
        id="message"
        role="tabpanel"
        aria-labelledby="message-tab"
      >
        <div class="asso-main-wrapper">
          <AsscoaitionMessageBoard
            :eventId="eventId"
            :messageBodyData="messageBodyData"
            :messageTopics="messageTopics"
            :showLoaderMessage="showLoaderMessage"
            :currentIsAdmin="currentIsAdmin"
            :currentIsUmpire="currentIsUmpire"
            :association_id="association_id"
            :showLoaderTournament="showLoaderTournament"
            :messagepage="messagepage"
            :msgLastPage="msgLastPage"
            :tournamentsData="tournamentsData"
            v-if="currentTab === 'message'"
            @get-division-pagination="handleDivisionPagination"
          />

          <AssociationEventInfo
            :association_id="association_id"
            :events="events"
            :eventId="eventId"
            :showLoader="showLoader"
            :eventSponsors="eventSponsors"
            :currentIsAdmin="currentIsAdmin"
            :eventHotels="eventHotels"
            :sponsorLoader="sponsorLoader"
            :hotelLoader="hotelLoader"
            :eventPlayingFacility="eventPlayingFacility"
            :playingFacilityLoader="playingFacilityLoader"
            v-if="currentTab === 'message'"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import AsscoaitionMessageBoard from "./AsscoaitionMessageBoard.vue";
import AssocaitionTournamentInfo from "./AssocaitionTournamentInfo.vue";
import AssociationEventInfo from "./AssociationEventInfo.vue";
import AssociationEventTop from "./AssociationEventTop.vue";
import AssociationTeamsInfo from "./AssociationTeamsInfo.vue";
import AssociationUmpiresInfo from "./AssociationUmpiresInfo.vue";
import AssociationFieldGridInfo from "./AssociationFieldGridInfo.vue";
import AssociationBoxScoresInfo from "./AssociationBoxScoresInfo.vue";
import AssociationScheduleInfo from "./AssociationScheduleInfo.vue";

export default {
  components: {
    AssociationTeamsInfo,
    AssociationEventInfo,
    AssocaitionTournamentInfo,
    AssociationUmpiresInfo,
    AsscoaitionMessageBoard,
    AssociationEventTop,
    AssociationBoxScoresInfo,
    AssociationScheduleInfo,
    AssociationFieldGridInfo,
  },
  name: "AssociationSingleEvent",
  data() {
    return {
      sponsorLoader: 1,
      hotelLoader: 1,
      playingFacilityLoader: 1,
      events: {},
      event_guid: "",
      editEventOption: false,
      tournamentsData: [],
      tournamentsLength: [],
      eventSponsors: [],
      eventHotels: [],
      showLoader: 1,
      showLoaderTeam: 1,
      showLoaderTournament: 0,
      showLoaderUmpire: 1,
      showLoaderMessage: 1,
      showFieldsLoader: 1,
      allFields: [],
      selectedFields: [],
      joinedTeams: [],
      umpireData: [],
      umpiresTotal: 0,
      divisionsTotal: 0,
      msgLastPage: 1,
      messageBodyData: [],
      association_id: 0,
      currentIsAdmin: "0",
      eventName: "",
      isAdminAssociation: false,
      currentIsUmpire: "0",
      messageTopics: [],
      eventPlayingFacility: [],
      page: 1,
      lastPage: 1,
      divisionPage: 1,
      divisionlastPage: 1,
      eventId: 0,
      currentTab: this.tournamentsLength?.length > 0 ? "schedule" : "team",
      umpirepage: 1,
      umpirelastPage: 1,
      messagepage: 1,
      isLoaded: {
        schedule: false,
        boxscore: false,
        team: false,
        tournament: false,
        umpire: false,
        message: false,
        grid: false,
      },
      eventExactStartDate: "",
      eventExactEndDate: "",
      tournamentGame: [],
      eventGame: [],
      event_follower_count: 0
    };
  },
  watch: {
    tournamentsLength(newVal) {
      if (newVal.length > 0) {
        if (newVal.length > 1) {
          return;
        } else {
          this.currentTab = "schedule"; // or 'teams'
        }
      } else {
        this.currentTab = "team";
      }
    },
  },
  methods: {
    incrementFollowerCount() {
      this.events.event_follower_count = (this.events.event_follower_count || 0) + 1;
    },
    decrementFollowerCount() {
      this.events.event_follower_count = Math.max((this.events.event_follower_count || 0) - 1, 0);
    },
    scrollToBoxScoreSection() {
      this.$nextTick(() => {
        this.$emit("scrollToBoxScore");
      });
    },
    openEditEventOption() {
      this.editEventOption = !this.editEventOption;
    },
    onClickOutside() {
      this.editEventOption = false;
    },
    handleUmpireTabClick() {
      this.$root.$emit("umpire-tab-clicked");
    },
    handleMessageBoardTabClick() {
      this.$root.$emit("message-Board-tab-clicked");
    },
    async EventsDetailData() {
      this.isLoaded.schedule = true;
      this.isLoaded.boxscore = true;
      this.isLoaded.team = true;
      this.isLoaded.tournament = true;
      this.isLoaded.umpire = true;
      this.isLoaded.grid = true;
      this.isLoaded.message = true;
      var url = window.location.pathname;
      var segment_array = url.split("/");
      const eventGuid = segment_array.pop();
      this.showLoader = 1;
      try {
        const response = await axios.post(
          `${process.env.VUE_APP_API_URL}event/tournamentListForAdminEvents?page=${this.page}`,
          { event_guid: eventGuid }
        );

        if (response.data.statusCode === 200) {
          this.events = response.data.data.teamEventData;
          this.eventExactStartDate = this.events.exactStartDate;
          this.eventExactEndDate = this.events.exactEndDate;
          this.association_id =
            response.data.data?.user_association_role?.association_id;

          this.currentIsAdmin = response.data.data.user_association_role
            ? response.data.data.user_association_role.role_id == 1
              ? "1"
              : "0"
            : "0";
          this.currentIsUmpire = response.data.data.user_association_role
            ? response.data.data.user_association_role.role_id == 2
              ? "1"
              : "0"
            : "0";
          this.teamId = response.data.data.teamEventData.team_id;
          this.eventId = this.events?.id;
          this.eventName = this.events.eventName;
          this.getPlayingFacility(this.eventId);
          this.getEventSponsor(this.eventId);
          this.getEventHotel(this.eventId);
          this.getJoinTeams(this.eventId);

          this.tournamentsData = response.data.data.eventTournaments.data;
          this.tournamentsLength = response.data.data.eventTournaments.data;

          // if (this.tournamentsData.length > 0) {
          //   const tournamentId = this.tournamentsData[0].id;
          //   localStorage.setItem("tournament_id", tournamentId);
          //   // const tournamentGuid = this.tournamentsData[0].guid;

          //   // localStorage.setItem("tournamentID", tournamentGuid);
          // }

          this.lastPage = response.data.data.tournamentsData.last_page;

          this.showLoader = 0;
        } else if (response.data.statusCode === 404) {
          this.$alert(response.data.message, "Error");
          this.$router.push({ name: "Teams" });

          this.showLoader = 0; // Hide loader
        } else {
          this.errorMessage = response.data.message || "Unknown error occurred";
          this.showLoader = 0;
        }
      } catch (error) {
        this.errorMessage = "Failed to fetch data";
        this.showLoader = 0;
      } finally {
        this.showLoader = 0;
      }
    },
    async getEventSponsor(event_id) {
      try {
        this.sponsorLoader = 1;
        const response = await axios.get(
          `${process.env.VUE_APP_API_URL}associationEvent/getSponsor?event_id=${event_id}`
        );

        if (response.data.statusCode === 200) {
          this.eventSponsors = response.data.data;
          this.sponsorLoader = 0;
        } else {
          this.errorMessage = response.data.message || "Unknown error occurred";
          this.sponsorLoader = 0;
        }
      } catch (error) {
        this.errorMessage = "Failed to fetch data";
        this.sponsorLoader = 0;
      }
      this.isLoaded.schedule = false;
      this.isLoaded.boxscore = false;
      this.isLoaded.team = false;
      this.isLoaded.tournament = false;
      this.isLoaded.umpire = false;
      this.isLoaded.grid = false;
      this.isLoaded.message = false;
    },
    async getEventHotel(event_id) {
      try {
        this.hotelLoader = 1;
        const response = await axios.get(
          `${process.env.VUE_APP_API_URL}associationEvent/getEventHotels?event_id=${event_id}`
        );

        if (response.data.statusCode === 200) {
          this.eventHotels = response.data.data;
          this.hotelLoader = 0;
        } else {
          this.errorMessage = response.data.message || "Unknown error occurred";
          this.hotelLoader = 0;
        }
      } catch (error) {
        this.errorMessage = "Failed to fetch data";
        this.hotelLoader = 0;
      }
      this.isLoaded.schedule = false;
      this.isLoaded.boxscore = false;
      this.isLoaded.team = false;
      this.isLoaded.tournament = false;
      this.isLoaded.umpire = false;
      this.isLoaded.grid = false;
      this.isLoaded.message = false;
    },
    async getPlayingFacility(event_id) {
      try {
        this.playingFacilityLoader = 1;
        const response = await axios.get(
          `${process.env.VUE_APP_API_URL}associationEvent/getEventPlayingFacility?event_id=${event_id}`
        );

        if (response.data.statusCode === 200) {
          this.eventPlayingFacility = response.data.data.parkDetails;
          this.playingFacilityLoader = 0;
        } else {
          this.errorMessage = response.data.message || "Unknown error occurred";
          this.playingFacilityLoader = 0;
        }
      } catch (error) {
        this.errorMessage = "Failed to fetch data";
        this.playingFacilityLoader = 0;
      }
    },

    async getJoinTeams() {
      this.isLoaded.schedule = true;
      this.isLoaded.boxscore = true;
      this.isLoaded.team = true;
      this.isLoaded.tournament = true;
      this.isLoaded.umpire = true;
      this.isLoaded.grid = true;
      this.isLoaded.message = true;
      this.showLoaderTeam = 1;
      try {
        const url = `${process.env.VUE_APP_API_URL}associationEvent/getJoinedTeam?page=${this.page}&event_id=${this.eventId}&association_id=${this.association_id}`;
        const response = await axios.get(url);
        if (response.data.statusCode === 200) {
          this.joinedTeams = response.data.data;
          this.showLoaderTeam = 0;
        }
        // else if (response.data.statusCode === 404) {
        //   this.$alert(response.data.message, 'Error');
        //   this.$router.push({ name: "Teams" });
        // }
        else {
          console.error(
            "Failed to fetch umpires:",
            response.data.message || "Unknown error occurred"
          );
          this.showLoaderTeam = 0;
        }
      } catch (error) {
        this.showLoaderTeam = 0;
        console.error("Failed to fetch umpires:", error);
      }
      this.isLoaded.schedule = false;
      this.isLoaded.boxscore = false;
      this.isLoaded.team = false;
      this.isLoaded.tournament = false;
      this.isLoaded.umpire = false;
      this.isLoaded.grid = false;
      this.isLoaded.message = false;
    },

    async TournamentsDetailData() {
      this.isLoaded.schedule = true;
      this.isLoaded.boxscore = true;
      this.isLoaded.team = true;
      this.isLoaded.tournament = true;
      this.isLoaded.umpire = true;
      this.isLoaded.grid = true;
      this.isLoaded.message = true;
      // var url = window.location.pathname;
      // var segment_array = url.split("/");
      // const eventGuid = segment_array.pop();
      this.showLoaderTournament = 1;

      var eventGuid = this.event_guid; // Use event_id if provided from emit

      // If no event_id was provided, extract it from the URL
      if (!eventGuid) {
        var url = window.location.pathname;
        var segment_array = url.split("/");
        eventGuid = segment_array.pop();
      }

      try {
        const response = await axios.post(
          `${process.env.VUE_APP_API_URL}event/tournamentListForAdminEvents?page=${this.divisionPage}`,
          { event_guid: eventGuid }
        );

        if (response.data.statusCode === 200) {
          const tournamentResponse = response.data.data.eventTournaments.data;
          this.divisionlastPage = response.data.data.eventTournaments.last_page;
          this.divisionsTotal = response.data.data.eventTournaments.total;
          // this.tournamentsLength =response.data.data.eventTournaments.data;

          if (this.divisionPage > 1) {
            const combined = [...this.tournamentsData, ...tournamentResponse];

            // Filter unique by `guid`
            const uniqueTournaments = combined.filter(
              (tournament, index, self) =>
                index === self.findIndex((t) => t.guid === tournament.guid)
            );

            this.tournamentsData = uniqueTournaments;
          } else {
            this.tournamentsData = tournamentResponse;
          }

          if (this.tournamentsData.length > 0) {
            const tournamentId = this.tournamentsData[0].id;
            localStorage.setItem("tournament_id", tournamentId);
          }

          this.showLoaderTournament = 0;
        } else if (response.data.statusCode === 404) {
          this.$alert(response.data.message, "Error");
          this.$router.push({ name: "Teams" });

          this.showLoader = 0; // Hide loader
        } else {
          this.errorMessage = response.data.message || "Unknown error occurred";
          this.showLoaderTournament = 0;
        }
      } catch (error) {
        this.errorMessage = "Failed to fetch data";
        this.showLoaderTournament = 0;
      } finally {
        this.showLoaderTournament = 0;
        this.$root.$emit("divisionPaginationLoaded");
      }
      this.isLoaded.schedule = false;
      this.isLoaded.boxscore = false;
      this.isLoaded.team = false;
      this.isLoaded.tournament = false;
      this.isLoaded.umpire = false;
      this.isLoaded.grid = false;
      this.isLoaded.message = false;
    },

    async getUmpires() {
      this.isLoaded.schedule = true;
      this.isLoaded.boxscore = true;
      this.isLoaded.team = true;
      this.isLoaded.tournament = true;
      this.isLoaded.umpire = true;
      this.isLoaded.grid = true;
      this.isLoaded.message = true;
      this.showLoaderUmpire = 1;
      try {
        const url = `${process.env.VUE_APP_API_URL}associationEvent/getUmpires?event_id=${this.eventId}&page=${this.umpirepage}&association_id=${this.association_id}`;
        const response = await axios.get(url);
        if (response.data.statusCode === 200) {
          const responseData = response.data.data.umpires.data;
          const normalizedData = Array.isArray(responseData)
            ? responseData
            : Object.values(responseData);
          this.umpirelastPage = response.data.data.umpires.last_page;
          if (this.umpirepage > 1) {
            this.umpireData = [...this.umpireData, ...normalizedData];
          } else {
            this.umpireData = normalizedData;
          }
          this.umpiresTotal = response.data.data.umpires.total;
        } else if (response.data.statusCode === 404) {
          this.$alert(response.data.message, "Error");
          this.$router.push({ name: "Teams" });
          this.showLoaderUmpire = 0;
        } else {
          console.error(
            "Failed to fetch umpires:",
            response.data.message || "Unknown error occurred"
          );
          this.showLoaderUmpire = 0;
        }
      } catch (error) {
        this.showLoaderUmpire = 0;
        console.error("Failed to fetch umpires:", error);
      }
      this.showLoaderUmpire = 0;
      this.isLoaded.schedule = false;
      this.isLoaded.boxscore = false;
      this.isLoaded.team = false;
      this.isLoaded.tournament = false;
      this.isLoaded.umpire = false;
      this.isLoaded.grid = false;
      this.isLoaded.message = false;
    },

    async getMessageBoards(topicId) {
      this.isLoaded.schedule = true;
      this.isLoaded.boxscore = true;
      this.isLoaded.team = true;
      this.isLoaded.tournament = true;
      this.isLoaded.umpire = true;
      this.isLoaded.message = true;
      this.isLoaded.grid = true;
      this.showLoaderMessage = 1;
      if (topicId !== undefined && topicId !== null) {
        this.messageBodyData = [];
        this.messagepage = 1;
      }
      try {
        let url = `${process.env.VUE_APP_API_URL}associationEvent/getMessageBoards?event_id=${this.eventId}&page=${this.messagepage}&association_id=${this.association_id}`;
        if (topicId !== undefined && topicId !== null) {
          url += `&topic_id=${topicId}`;
        }

        const response = await axios.get(url);
        if (response.data.statusCode === 200) {
          const responseData = response.data.data.messageBoards.data;
          this.msgLastPage = response.data.data.messageBoards.last_page;

          // Clear the existing messageBodyData if a filter is applied

          if (this.messagepage > 1) {
            this.messageBodyData = [...this.messageBodyData, ...responseData];
          } else {
            this.messageBodyData = responseData;
          }
          // this.messageBodyData = this.messageBodyData.concat(responseData);
          this.showLoaderMessage = 0;
        } else if (response.data.statusCode === 404) {
          this.$alert(response.data.message, "Error");
          this.$router.push({ name: "Teams" });
          this.showLoaderMessage = 0;
        } else {
          console.error(
            "Failed to fetch message boards:",
            response.data.message || "Unknown error occurred"
          );
          this.showLoaderMessage = 0;
        }
      } catch (error) {
        this.showLoaderMessage = 0;
        console.error("Failed to fetch message boards:", error);
      }
      this.isLoaded.schedule = false;
      this.isLoaded.boxscore = false;
      this.isLoaded.team = false;
      this.isLoaded.tournament = false;
      this.isLoaded.umpire = false;
      this.isLoaded.message = false;
      this.isLoaded.grid = false;
    },

    async getMessageTopics() {
      try {
        const response = await axios.get(
          `${process.env.VUE_APP_API_URL}associationEvent/getMessageTopics`
        );

        if (response.data.statusCode === 200) {
          this.messageTopics = response.data.data.messageTopics;
        } else {
          console.error(
            "Failed to fetch umpires:",
            response.data.message || "Unknown error occurred"
          );
        }
      } catch (error) {
        console.error("Failed to fetch umpires:", error);
      }
    },

    async getEventGames() {
      var url = window.location.pathname;
      var segment_array = url.split("/");
      const eventGuid = segment_array.pop();
      this.showLoader = 1;
      try {
        const response = await axios.post(
          `${process.env.VUE_APP_API_URL}tournaments/getEventGames`,
          { event_guid: eventGuid }
        );

        if (response.data.statusCode === 200) {
          this.tournamentGame =
            response.data.data.tournamentGames &&
            response.data.data.tournamentGames
              ? response.data.data.tournamentGames
              : [];
            console.log("Event Games Response:",  this.tournamentGame.length);

        } else if (
          response.data.statusCode === 404 ||
          response.data.statusCode === 403
        ) {
          this.$alert(response.data.message, "Error");
          this.$router.push({ name: "Teams" });
          this.showLoader = 0;
        } else if (response.data.statusCode === 400) {
          this.showLoader = 0;
          this.$alert("Event not found").then(() => {
            window.history.back();
          });
        } else {
          this.errorMessage = response.data.message || "Unknown error occurred";
          this.showLoader = 0;
        }
      } catch (error) {
        this.errorMessage = "Failed to fetch data";
        this.showLoader = 0;
      } finally {
        this.showLoader = 0;
      }
    },

    handleMessageBoardPagination() {
      this.messagepage++;
      this.getMessageBoards();
    },

    handleDivisionPagination() {
      if (this.divisionPage <= this.divisionlastPage) {
        this.divisionPage++;
        this.TournamentsDetailData();
      }
    },

    handleUmpirePagination() {
      this.umpirepage++;
      this.getUmpires();
    },

    selectTab(tab) {
      this.currentTab = tab;
      if (tab === "schedule") {
        let tourID = localStorage.getItem("tournamentID");
        if (tourID) {
          this.TournamentsDetailData();
        } else {
          this.EventsDetailData();
          this.getEventGames();
        }
      }
      if (tab === "boxscore") {
        // this.EventsDetailData();
        this.getUmpires();
      }
      if (tab === "team") {
        this.getJoinTeams();
      }
      if (tab === "tournament") {
        this.TournamentsDetailData();
      }
      if (tab === "umpire") {
        this.umpirepage = 1;
        this.umpireData = [];
        this.getUmpires();
      }
      if (tab === "grid") {
        if (this.$refs.fieldGridComponent) {
          this.$refs.fieldGridComponent.getParkField();
          this.$refs.fieldGridComponent.getEventGamesSchedule();
        }
      }
      if (tab === "message") {
        this.messagepage = 1;
        this.messageBodyData = [];
        this.getMessageBoards();
        this.getMessageTopics();
      }
    },
  },
  mounted() {
    this.EventsDetailData();
    this.getEventGames();
    this.$root.$on("ReloadTabs", () => {
      if (this.tournamentsData.length == 0) {
        this.EventsDetailData();
        this.getEventGames();
      } else {
        return;
      }
    });
    this.$root.$on("fetchMesagesForTopics", (topic) => {
      this.getMessageBoards(topic);
    });
    this.$root.$on("sponsorAdded", () => {
      this.getEventSponsor(this.eventId);
    });
    this.$root.$on("fetchEventDataOnEdit", () => {
      this.EventsDetailData();
      this.getventGames();
    });

    this.$root.$on("sponsorUpdated", () => {
      this.getEventSponsor(this.eventId);
    });
    this.$root.$on("hotelAddedEmit", () => {
      this.getEventHotel(this.eventId);
    });
    this.$root.$on("selectedUmpireEmit", () => {
      this.umpireData = [];
      this.getUmpires();
    });
    this.$root.$on("fetchTournaments1", (data) => {
      this.tournamentsData = [];
      this.divisionPage = 1;
      this.event_guid = data;
      this.TournamentsDetailData();
    });
    this.$root.$on("fetchTournaments", () => {
      this.divisionPage = 1;
      this.event_guid = "";
      this.tournamentsData = [];
      this.TournamentsDetailData();
    });
    this.$root.$on("selectedTeamEmit", () => {
      this.joinedTeams = [];
      this.getJoinTeams();
    });
    this.$root.$on("selectedParkEmit", () => {
      this.getPlayingFacility(this.eventId);
    });
    this.$root.$on("getMessageBoards", () => {
      this.handleMessageBoardPagination();
    });
    this.$root.$on("getDivisionPagination", () => {
      this.handleDivisionPagination();
    });
    this.$root.$on("getUmpires", () => {
      this.handleUmpirePagination();
    });
    this.$root.$on("fetchMesages", () => {
      this.getMessageBoards();
    });
    this.$root.$on("eventsIdForDetails", (data) => {
      this.events = data;
    });
    let defaultTab = localStorage.getItem("defaultEventTab") || "schedule";
    this.eventId = localStorage.getItem("eventid");
    this.association_id = localStorage.getItem("association_id");
    this.selectTab(defaultTab);
    setTimeout(() => {
      localStorage.removeItem("defaultEventTab"); // clean up
    }, 1000);
  },
};
</script>
